import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import { Notification } from "@/hooks/useNotifications";

interface NotificationActionsProps {
  notification: Notification;
  onMarkAsRead: () => void;
}

export function NotificationActions({
  notification,
  onMarkAsRead,
}: NotificationActionsProps) {
  const getActionLink = () => {
    switch (notification.type) {
      case "profile_completion":
        return "/profile";
      case "sponsor_invite":
        return "/artist/dashboard";
      case "artist_invite":
        return "/sponsor/dashboard";
      case "profile_comment":
        return `/profiles/${notification.data?.commenter_username || "#"}`;
      default:
        return "#";
    }
  };

  if (notification.is_read) {
    return null;
  }

  return (
    <div className="mt-3 flex justify-end space-x-2">
      <Button
        variant="ghost"
        size="sm"
        className="h-7 text-xs"
        onClick={onMarkAsRead}
      >
        <Check className="h-3.5 w-3.5 mr-1" />
        Mark as read
      </Button>

      {notification.type !== "welcome" &&
        notification.type !== "system_update" &&
        notification.type !== "artist_invite" && (
          <Button variant="outline" size="sm" className="h-7 text-xs" asChild>
            <Link to={getActionLink()}>View</Link>
          </Button>
        )}
    </div>
  );
}
